import { useState, useEffect, useCallback, useMemo } from 'react'
import { productService } from '../services'
import {
  normalizeProducts,
  toProductApiParams,
} from '../utils/productManagementUtils'

/**
 * Fetch product list from URL-derived UI filters.
 * @param {{ q: string, page: number, limit: number }} filters
 */
export function useProductList(filters) {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [totalCount, setTotalCount] = useState(0)

  const apiParams = useMemo(
    () => toProductApiParams(filters || {}),
    [filters?.q, filters?.page, filters?.limit],
  )

  const fetchProducts = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await productService.getMyUploads(apiParams)
      setProducts(normalizeProducts(response.items || response.data || []))
      setTotalCount(response.pagination?.total || 0)
    } catch (err) {
      console.error('Error fetching products:', err)
      setError(err.response?.data?.message || 'Failed to fetch products')
    } finally {
      setLoading(false)
    }
  }, [apiParams])

  useEffect(() => {
    fetchProducts()
  }, [fetchProducts])

  return {
    products,
    loading,
    error,
    setError,
    page: filters?.page ?? 0,
    rowsPerPage: filters?.limit ?? 10,
    totalCount,
    fetchProducts,
  }
}
